module.exports = __webpack_public_path__ + "img/banner2 - Consorcio_Rio_Guandu_2.c9bc3614.png";